























































































































































import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import CtrlJigyosho from '@/components/common/search/CtrlJigyosho.vue';
import CtrlSoko from '@/components/common/search/CtrlSoko.vue';
import CtrlTokuisaki from '@/components/common/search/CtrlTokuisaki.vue';
import G_060_ShukkaJunbi_Table from '@/components/G_kaigai/G_060_ShukkaJunbi_Table.vue';
import G_060_ShukkaJunbi_ChildHeaderInput from '@/components/G_kaigai/G_060_ShukkaJunbi_ChildHeaderInput.vue';
import G_060_ShukkaJunbi_BatchOrderEditing from '@/components/G_kaigai/G_060_ShukkaJunbi_BatchOrderEditing.vue';
import {
  OutStatus,
  SeikyusakiKb,
  SumiFlg,
  UmuFlg,
  KaigaiKobetsuKb,
} from '@/constants/constants';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { dateStrToNum } from '@/utils/utils';

export default Vue.extend<any, any, any, any>({
  name: 'G_060_ShukkaJunbi',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlDatePicker,
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlSoko,
    CtrlTokuisaki,
    CtrlJigyosho,
    G_060_ShukkaJunbi_Table,
    G_060_ShukkaJunbi_ChildHeaderInput,
    G_060_ShukkaJunbi_BatchOrderEditing,
  },
  data: () => ({
    UmuFlg,
    SeikyusakiKb,
    KaigaiKobetsuKb,
    nohinYoteiYmdF: '',
    nohinYoteiYmdT: '',
    shukkaYoteiYmdF: '',
    shukkaYoteiYmdT: '',
    shukkaSokoCd: 0,
    tokuisakiCd: 0,
    entryJigyoshoCd: 0,
    nyukoJigyoshoCd: 0,
    search: '',
    items: [],
    selected: [],
    shukkaHassoSumiFlg: false,
    childHeaderInputItem: {},
    childHeaderInputShow: false,
    batchOrderEditingShow: false,

    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isReload: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    itemsSelected() {
      return this.selected
        .filter((item: any) => item.kakuteiSumiFlg === SumiFlg.MI)
        .map((item: any) => ({
          shiiresakiCd: this.userInfo.shiiresakiCd,
          orderNo: item.orderNo,
          shukkaYoteiYmd: dateStrToNum(item.shukkaYoteiYmd),
          nohinYoteiYmd: dateStrToNum(item.nohinYoteiYmd),
          shukkaJigyoshoCd: +item.shukkaJigyoshoCd,
          shukkaSokoCd: +item.shukkaSokoCd,
          haisoKb: +item.haisoKb,
          haisoTehaiKb: +item.haisoTehaiKb,
          tokuisakiCd: +item.tokuisakiCd,
          nohinsakiCd: +item.nohinsakiCd,
          nyukoJigyoshoCd: +item.nyukoJigyoshoCd,
          nyukoSokoCd: +item.nyukoSokoCd,
          haisoKaishaCd: +item.haisoKaishaCd,
          nyuryokuSumiFlg: +item.nyuryokuSumiFlg,
          juchuEntryJigyoshoCd: +item.juchuEntryJigyoshoCd,
          juchuEntryYmd: dateStrToNum(item.juchuEntryYmd),
          juchuNo: +item.juchuNo,
          hatchuIraiJigyoshoCd: +item.hatchuIraiJigyoshoCd,
          hatchuIraiEntryYmd: dateStrToNum(item.hatchuIraiEntryYmd),
          hatchuIraiNo: +item.hatchuIraiNo,
          idoIraiJigyoshoCd: +item.idoIraiJigyoshoCd,
          idoIraiEntryYmd: dateStrToNum(item.idoIraiEntryYmd),
          idoIraiNo: +item.idoIraiNo,
          koshinCountHeader: +item.koshinCountHeader,
          koshinCountDetailSum: +item.koshinCountDetailSum,
        }));
    },
  },
  methods: {
    async initValues() {
      this.nohinYoteiYmdF = this.userInfo.onlineData.genzaiYmd;
      this.nohinYoteiYmdT = moment(
        this.userInfo.onlineData.genzaiYmd.toString()
      )
        .add(1, 'month')
        .format()
        .substr(0, 10);
      this.shukkaSokoCd = 0;
      this.shukkaYoteiYmdF = '';
      this.shukkaYoteiYmdT = '';
      this.entryJigyoshoCd = 0;
      this.tokuisakiCd = 0;
      this.nyukoJigyoshoCd = 0;
      this.search = '';
      this.nyuryokuSumiFlg = false;
      this.selected = [];
      this.items = [];
    },
    async handleReset() {
      if (await this.checkValidate()) {
        this.items = [];
        this.getData();
      }
    },
    handlClear() {
      this.initValues();
    },
    handleOKmessage() {
      if (this.messageId == 'KI_W123') {
        window.location.href = '/';
      }
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;
    },
    callbackOkSoko(item: any) {
      if (item && item.sokoCd) {
        this.shukkaSokoCd = +item.sokoCd;
      } else {
        this.shukkaSokoCd = 0;
      }
    },
    callbackOkTokuisaki(item: any) {
      if (item && item.tokuisakiCd) {
        this.tokuisakiCd = +item.tokuisakiCd;
      } else {
        this.tokuisakiCd = 0;
      }
    },
    callbackOkEntryJigyosho(item: any) {
      if (item && item.jigyoshoCd) {
        this.entryJigyoshoCd = +item.jigyoshoCd;
        this.tokuisakiCd = 0;
      } else {
        this.entryJigyoshoCd = 0;
        this.tokuisakiCd = 0;
      }
    },
    callbackOkNyukoJigyosho(item: any) {
      if (item && item.jigyoshoCd) {
        this.nyukoJigyoshoCd = +item.jigyoshoCd;
      } else {
        this.nyukoJigyoshoCd = 0;
      }
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (
        !dateStrToNum(this.nohinYoteiYmdF) &&
        !dateStrToNum(this.nohinYoteiYmdT) &&
        !dateStrToNum(this.shukkaYoteiYmdF) &&
        !dateStrToNum(this.shukkaYoteiYmdT) &&
        !this.shukkaSokoCd &&
        !this.tokuisakiCd &&
        !this.entryJigyoshoCd &&
        !this.nyukoJigyoshoCd
      ) {
        this.messageId = 'KI_W113';
        this.messageTextParam = ['検索条件'];
        this.messageShow = true;
        return;
      }
      if (
        this.nohinYoteiYmdF &&
        this.nohinYoteiYmdT &&
        dateStrToNum(this.nohinYoteiYmdF) > dateStrToNum(this.nohinYoteiYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['納品予定日'];
        this.messageShow = true;
        return;
      }
      if (
        this.shukkaYoteiYmdF &&
        this.shukkaYoteiYmdT &&
        dateStrToNum(this.shukkaYoteiYmdF) > dateStrToNum(this.shukkaYoteiYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['出荷予定日'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      this.selected = [];
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        kaigaiKobetsuKb: this.userInfo.kaigaiKobetsuKb,
        shiiresakiCd: this.userInfo.shiiresakiCd,
        nohinYoteiYmdF: dateStrToNum(this.nohinYoteiYmdF),
        nohinYoteiYmdT: dateStrToNum(this.nohinYoteiYmdT),
        shukkaYoteiYmdF: dateStrToNum(this.shukkaYoteiYmdF),
        shukkaYoteiYmdT: dateStrToNum(this.shukkaYoteiYmdT),
        shukkaSokoCd: this.shukkaSokoCd,
        tokuisakiCd: this.tokuisakiCd,
        entryJigyoshoCd: this.entryJigyoshoCd,
        nyukoJigyoshoCd: this.nyukoJigyoshoCd,
      };
      const res = await this.$store.dispatch('g060/getJunbi', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        this.isReload = true;
        return;
      }
      this.items = res.data.responseData
        ? res.data.responseData.map((i: any, index: number) => ({
            ...i,
            id: `${index + 1}${i.orderNo}`,
          }))
        : [];
    },
    handleItemDetail(item: any) {
      this.childHeaderInputItem = item;
      this.childHeaderInputShow = true;
    },
    handleChildHeaderInputHide(reload: boolean) {
      if (reload) {
        this.getData();
      }
    },
    handleBatchOrderEditingHide(reload: boolean) {
      if (reload) {
        this.selected = [];
        this.getData();
      }
    },
  },
  created() {
    if (!this.userInfo.shiiresakiCd) {
      this.messageId = 'KI_W123';
      this.messageTextParam = ['利用者マスタの仕入先が未設定の', '実行'];
      this.messageShow = true;
      return;
    }
    this.initValues();
  },
});
